import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { priceEUR } from "../../helper/functions";

const PickDough = ({ dough, addDough }) => {
  return (
    <div>
      <Row className="align-center">
        <Col>
          <h5 className="mt-2">{dough.name}</h5>
        </Col>
        <Col>
          <Button
            variant="outline-success"
            className="float-end"
            onClick={() => addDough(dough)}
          >
            + Add
          </Button>
          <div className="float-end mt-3 me-2">{priceEUR(dough.price)}</div>
        </Col>
      </Row>
      <Row>
        <div>{dough.desc}</div>
      </Row>
      <hr />
    </div>
  );
};

export default PickDough;
